<script setup lang="ts">
import EventLogBrowser from '~components/admin/EventLogBrowser.vue'
import SelfLink from '~components/widgets/SelfLink.vue'
</script>

<template>
  <b-container fluid>
    <h1><self-link href="/admin/events">Event Logs</self-link></h1>
    <hr>
    <event-log-browser />
  </b-container>
</template>
